// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Permissions-Table-style___table--PE1UE {
  background: #fff;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  font-weight: 600;
  font-size: 15px;
  width: -moz-fit-content;
  width: fit-content;
}

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ {
    display: flex;
    border-bottom: 1px solid #e0e2e6;
  }

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ.components-Permissions-Table-style___header--hg54G {
      background: #edeeef;
    }

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ.components-Permissions-Table-style___header--hg54G .components-Permissions-Table-style___column--cI4l0 {
        background: #edeeef;
      }

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ:first-child {
      font-size: 13px;
    }

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ:first-child .components-Permissions-Table-style___column--cI4l0 {
        height: 76px;
      }

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ:last-child {
      border-bottom: none;
    }

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ .components-Permissions-Table-style___column--cI4l0 {
      flex: 1;
      padding: 0 32px;
      justify-content: center;
      border-right: 1px solid #e0e2e6;
      height: 66px;
      align-items: center;
      display: flex;
      min-width: 160px;
      background: #fff;
    }

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ .components-Permissions-Table-style___column--cI4l0:first-child {
        flex: 2;
        padding: 0 32px 0 0;
        padding-left: 32px;
        position: sticky;
        left: 0;
        z-index: 999;
      }

  .components-Permissions-Table-style___table--PE1UE .components-Permissions-Table-style___row--qN7MZ .components-Permissions-Table-style___column--cI4l0:last-child {
        border-right: none;
      }
`, "",{"version":3,"sources":["webpack://./components/Permissions/Table/style.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AAmDpB;;EAjDE;IACE,aAAa;IACb,gCAAgC;EA8ClC;;EA5CE;MACE,mBAAmB;IAKrB;;EAHE;QACE,mBAAmB;MACrB;;EAGF;MACE,eAAe;IAKjB;;EAHE;QACE,YAAY;MACd;;EAGF;MACE,mBAAmB;IACrB;;EAEA;MACE,OAAO;MACP,eAAe;MACf,uBAAuB;MACvB,+BAA+B;MAC/B,YAAY;MACZ,mBAAmB;MACnB,aAAa;MACb,gBAAgB;MAChB,gBAAgB;IAclB;;EAZE;QACE,OAAO;QACP,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,OAAO;QACP,YAAY;MACd;;EAEA;QACE,kBAAkB;MACpB","sourcesContent":[".table {\n  background: #fff;\n  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 15px;\n  width: fit-content;\n\n  .row {\n    display: flex;\n    border-bottom: 1px solid #e0e2e6;\n\n    &.header {\n      background: #edeeef;\n\n      .column {\n        background: #edeeef;\n      }\n    }\n\n    &:first-child {\n      font-size: 13px;\n\n      .column {\n        height: 76px;\n      }\n    }\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .column {\n      flex: 1;\n      padding: 0 32px;\n      justify-content: center;\n      border-right: 1px solid #e0e2e6;\n      height: 66px;\n      align-items: center;\n      display: flex;\n      min-width: 160px;\n      background: #fff;\n\n      &:first-child {\n        flex: 2;\n        padding: 0 32px 0 0;\n        padding-left: 32px;\n        position: sticky;\n        left: 0;\n        z-index: 999;\n      }\n\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `components-Permissions-Table-style___table--PE1UE`,
	"row": `components-Permissions-Table-style___row--qN7MZ`,
	"header": `components-Permissions-Table-style___header--hg54G`,
	"column": `components-Permissions-Table-style___column--cI4l0`
};
module.exports = ___CSS_LOADER_EXPORT___;
